import { ValueDefaultFilters } from "./interface";

const DEFAUT_VALUEE_FILTERS: ValueDefaultFilters = {
	remountTransactionType: [],
	checkRemountTransactionType: false,
	//
	status: [],
	checkStatus: false,
	//
	transactionType: [],
	checkTransactionType: false,
};

// eslint-disable-next-line import/prefer-default-export
export { DEFAUT_VALUEE_FILTERS };
